'use client';

import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { TrackableLink } from '../../../components/TrackableLink';

interface ReadingListsTitleProps {
  theme: 'light' | 'dark';
}

export function ReadingListsTitle({ theme }: ReadingListsTitleProps) {
  const { t } = useTranslation();

  return (
    <div className="relative z-10">
      <div className="flex justify-between sm:justify-start items-end gap-8">
        <h2 className={`text-xl md:text-2xl font-semibold ${theme === 'light' ? 'text-neutral-900' : 'text-white'}`}>
          {t('reading_lists:lists_shelf_title')}
        </h2>
        <TrackableLink
          prefetch={false}
          path="/lists"
          className={'text-sm pb-[2px] lg:pb-[3px] lg:text-sm font-semibold text-primary-100 text-nowrap'}
          trackingInfo={{
            name: 'reading-lists-view-all-clicked',
            properties: { source: 'home_page' },
          }}
        >
          {t('discovery:view_all')}
        </TrackableLink>
      </div>
      <p className={`text-sm ${theme === 'light' ? 'text-neutral-700' : 'text-neutral-400'} mt-1`}>
        <Trans
          i18nKey="reading_lists:lists_shelf_subtitle"
          components={[
            <TrackableLink
              key="0"
              prefetch={false}
              path="/lists"
              className="font-semibold text-primary-100"
              trackingInfo={{
                name: 'reading-lists-subtitle-link-clicked',
                properties: { source: 'home_page' },
              }}
            >
              {''}
            </TrackableLink>,
          ]}
        />
      </p>
    </div>
  );
}
